export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./password-restore.vue?vue&type=template&id=54b60a24"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/password-restore/password-restore.vue?vue&type=template&id=54b60a24
// module id = RjOl
// module chunks = 0